import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { Apartments, ValuesStat } from "./data-contracts";

export const getAppLegacyApartmentsGetapartments = (id: number, params?: IFetchConfig) =>
  fetch<Apartments[]>("GET", `building/${id}/apartment`, null, params);

export const getAppMeteringdeviceGetdevicesstatbybuilding = (id: number, params?: IFetchConfig) =>
  fetch<ValuesStat>("GET", `building/${id}/metering/device/stat`, null, params);

export const getAppMeteringdeviceGetmeteringdevicesreport = (
  id: number,
  query: {
    from: string;
    before: string;
  },
  params?: IFetchConfig,
) => fetch<void>("GET", `building/${id}/metering/device/report`, query, params);
